import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { WHY_DHOLERA } from "../../lib/data";

export default function WhyDholera() {
  return (
    <section
      data-testid="why-dholera"
      className="relative py-28 md:py-40 px-6 md:px-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <div className="eyebrow mb-4">Why Dholera</div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white font-light leading-[1.05]">
              India&apos;s first{" "}
              <span className="gold-gradient-text italic">greenfield</span>{" "}
              smart city.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-white/60 text-lg font-light leading-relaxed">
              Government-backed infrastructure, multi-decade growth potential,
              and a vision twice the size of Delhi — Dholera is a generational
              investment opportunity hiding in plain sight.
            </p>
          </div>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {WHY_DHOLERA.map((item, i) => {
            const Icon = Icons[item.icon] || Icons.Sparkles;
            return (
              <motion.div
                key={item.title}
                data-testid={`why-dholera-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, delay: i * 0.06 }}
                className={`glass p-8 md:p-10 group hover:border-[#D4AF37]/40 hover:-translate-y-1 transition-all duration-500 ${
                  item.span || ""
                }`}
              >
                <Icon
                  className="w-7 h-7 text-[#D4AF37] mb-6"
                  strokeWidth={1.2}
                />
                <h3 className="font-serif text-2xl md:text-3xl text-white mb-3 font-light">
                  {item.title}
                </h3>
                <p className="text-white/60 text-sm leading-relaxed font-light">
                  {item.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
